
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bbZCI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aXWIB = parcelRequire("aXWIB");

var $479a090f69cfa515$exports = {};

var $qeApQ = parcelRequire("qeApQ");


var $haupJ = parcelRequire("haupJ");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $479a090f69cfa515$var$find = $qeApQ($haupJ);
$479a090f69cfa515$exports = $479a090f69cfa515$var$find;



var $kyKWe = parcelRequire("kyKWe");


var $2XqLN = parcelRequire("2XqLN");


var $inPa6 = parcelRequire("inPa6");


var $if5rb = parcelRequire("if5rb");


var $4TXTZ = parcelRequire("4TXTZ");


var $cH0F8 = parcelRequire("cH0F8");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $e4o8D = parcelRequire("e4o8D");


var $5Abqh = parcelRequire("5Abqh");


var $kVysQ = parcelRequire("kVysQ");


var $9eE57 = parcelRequire("9eE57");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $id4ij = parcelRequire("id4ij");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aMcHK = parcelRequire("aMcHK");


var $4PPzL = parcelRequire("4PPzL");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $6mKj3 = parcelRequire("6mKj3");


var $gqqjz = parcelRequire("gqqjz");


var $ep3mz = parcelRequire("ep3mz");


var $7xVCs = parcelRequire("7xVCs");


var $dncjA = parcelRequire("dncjA");


var $dPJCf = parcelRequire("dPJCf");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7Sm4c = parcelRequire("7Sm4c");


var $huWyw = parcelRequire("huWyw");


var $de2j9 = parcelRequire("de2j9");


var $lqy4C = parcelRequire("lqy4C");


var $6g38M = parcelRequire("6g38M");


var $ivyMZ = parcelRequire("ivyMZ");


var $lUMkS = parcelRequire("lUMkS");








var $3aAh8 = parcelRequire("3aAh8");

function $23e76f192fd1fdb2$export$4240bef965f11267({ item: item, ...passThroughRenderItemParams }, additionalParams) {
    const { scrollToItem: scrollToItem, onPageHighlighted: onPageHighlighted, onClick: onClick, onExpand: onExpand, onCollapse: onCollapse, spaceId: spaceId, openQuickActionsId: openQuickActionsId, focusedQuickActionsId: focusedQuickActionsId, editingTitle: editingTitle, pageTreeWasSSRRendered: pageTreeWasSSRRendered, getContentTreeSize: getContentTreeSize, renderServerPlaceholder: renderServerPlaceholder = false, ...passThroughAdditionalParams } = additionalParams;
    const isDraft = item.data.status === 'DRAFT';
    const contentStatus = item.data.status;
    const scrollToRef = (()=>{
        // skip scrollTo if page is SSR'd, SSR scrolling is handled by separate script
        if (!pageTreeWasSSRRendered) return (el)=>{
            scrollToItem(item, el);
        };
    })();
    const isQuickActionsOpen = openQuickActionsId === item.id;
    const isQuickActionsFocused = focusedQuickActionsId === item.id;
    const onHighlight = ()=>onPageHighlighted(item.id);
    const onClickWithItem = (event)=>{
        onClick(event, item, onExpand, onCollapse, spaceId, getContentTreeSize);
    };
    const pageItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "item",
        "data-testid": "page-tree-item-wrapper",
        "data-vc": "page-tree-item-wrapper",
        "data-ssr-placeholder": renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        "data-ssr-placeholder-replace": window.__SSR_RENDERED__ === true && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        ref: scrollToRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aAh8.PageTreeItem), {
        ...passThroughRenderItemParams,
        ...passThroughAdditionalParams,
        "data-testid": "page-tree-item",
        item: item,
        onHighlight: onHighlight,
        onClick: onClickWithItem,
        isQuickActionsOpen: isQuickActionsOpen,
        isQuickActionsFocused: isQuickActionsFocused,
        editingTitle: editingTitle,
        isDraft: isDraft,
        contentStatus: contentStatus,
        renderServerPlaceholder: renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false)
    }));
    return pageItem;
}



var $55DRn = parcelRequire("55DRn");


var $88DkZ = parcelRequire("88DkZ");

class $cb5c80eb65176243$export$fbe5b8b514d54d78 {
    push({ undo: undo }) {
        this.stack.push({
            undo: undo
        });
        this.stack = this.stack.slice(-1 * this.size);
    }
    constructor(){
        this.size = 1;
        this.stack = [];
        this.pop = ()=>this.stack.pop();
        this.peek = ()=>this.stack.slice(-1)[0];
        this.reset = ()=>{
            this.stack = [];
        };
    }
}



var $1q7H7 = parcelRequire("1q7H7");


var $6FfmH = parcelRequire("6FfmH");


var $cdzEA = parcelRequire("cdzEA");


var $6CrbN = parcelRequire("6CrbN");


var $bP5d8 = parcelRequire("bP5d8");

const $a4f80453e05e0dd2$var$noop = ()=>{};
const $a4f80453e05e0dd2$var$canMoveInSpace = (0, $2XqLN.default)((space)=>{
    return !!(0, (/*@__PURE__*/$parcel$interopDefault($479a090f69cfa515$exports)))(space?.operations ?? [], {
        targetType: 'page',
        operation: 'create'
    });
}, ([newSpace], [lastSpace])=>{
    return newSpace?.id === lastSpace?.id;
});
const $a4f80453e05e0dd2$var$isMovePagePermissionError = ({ graphQLErrors: graphQLErrors })=>{
    if (!graphQLErrors?.length) return false;
    for (const graphQLError of graphQLErrors){
        if (Array.isArray(graphQLError.path) && graphQLError.path.some((p)=>p.includes('movePage')) && (0, $aMcHK.getStatusCode)(graphQLError) === '403') return true;
        if (graphQLError.message?.includes('PermissionException')) return true;
    }
    return false;
};
const $a4f80453e05e0dd2$var$usePageTreeMoveHistory = ({ spaceKey: spaceKey, flags: flags, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
    const previousSpaceKeyRef = (0, $42omo.useRef)(spaceKey);
    const pageMoveHistoryRef = (0, $42omo.useRef)(new (0, $cb5c80eb65176243$export$fbe5b8b514d54d78)());
    const undo = (0, $42omo.useCallback)(()=>{
        const reverseMovement = pageMoveHistoryRef.current.pop();
        if (reverseMovement) {
            const { undo: undoFn } = reverseMovement;
            if (undoFn) undoFn();
        }
    }, []);
    const onUndoShortcut = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent((0, $88DkZ.undoShortcutUIEvent)()).fire();
        undo();
    }, [
        createAnalyticsEvent,
        undo
    ]);
    const showUndoFlag = (0, $42omo.useCallback)((pageTitle)=>{
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        flags.showSuccessFlag({
            id: id,
            title: pageTitle ? intl.formatMessage((0, $bP5d8.i18n).flagUndoTitle, {
                pageTitle: pageTitle
            }) : intl.formatMessage((0, $bP5d8.i18n).flagUndoUntitled),
            actions: [
                {
                    content: intl.formatMessage((0, $bP5d8.i18n).flagUndoAction),
                    onClick: ()=>{
                        createAnalyticsEvent((0, $88DkZ.undoClickUIEvent)()).fire();
                        undo();
                        flags.hideFlag(id);
                    }
                }
            ],
            isAutoDismiss: true
        });
        const historyEntry = pageMoveHistoryRef.current.peek();
        if (historyEntry) historyEntry.flagId = id;
    }, [
        flags,
        intl,
        createAnalyticsEvent,
        undo
    ]);
    const hideLastUndoFlag = (0, $42omo.useCallback)(()=>{
        const lastMovement = pageMoveHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
    }, [
        flags
    ]);
    const addUndo = (0, $42omo.useCallback)(({ undo: undo_0 })=>{
        pageMoveHistoryRef.current.push({
            undo: undo_0
        });
    }, []);
    if (spaceKey !== previousSpaceKeyRef.current) {
        previousSpaceKeyRef.current = spaceKey;
        hideLastUndoFlag();
        pageMoveHistoryRef.current.reset();
    }
    return {
        onUndoShortcut: onUndoShortcut,
        showUndoFlag: showUndoFlag,
        hideLastUndoFlag: hideLastUndoFlag,
        addUndo: addUndo
    };
};
const $a4f80453e05e0dd2$var$useScrollToItem = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    const scrolledItemIdRef = (0, $42omo.useRef)();
    let t1;
    if ($[0] !== pageTreeStateUpdatesContainer) {
        t1 = (item, el)=>{
            if (pageTreeStateUpdatesContainer.state.scrollToPageId === item.id && el) {
                (0, $id4ij.scrollElementToViewCenter)(el);
                pageTreeStateUpdatesContainer.clearScrollToPageId();
                return;
            }
            if (!pageTreeStateUpdatesContainer.state.editingTitle?.contentId && (item.data.isSelected || item.data.isHighlighted)) {
                if (pageTreeStateUpdatesContainer.state.scrollToCurrent && item.data.isSelected && el) {
                    (0, $id4ij.scrollElementToViewCenter)(el);
                    pageTreeStateUpdatesContainer.clearScrollTo();
                    return;
                }
                if (scrolledItemIdRef.current !== item.id) (0, $id4ij.scrollElementToViewCenter)(el);
                scrolledItemIdRef.current = item.id;
            }
        };
        $[0] = pageTreeStateUpdatesContainer;
        $[1] = t1;
    } else t1 = $[1];
    const scrollToItem = t1;
    let t2;
    if ($[2] !== scrollToItem) {
        t2 = [
            scrollToItem
        ];
        $[2] = scrollToItem;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $a4f80453e05e0dd2$var$usePageHighlight = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const highlightedPages = (0, $42omo.useRef)(t1);
    let t2;
    if ($[1] !== pageTreeStateUpdatesContainer) {
        t2 = (id)=>{
            highlightedPages.current.push(id);
            const pagesInTreeHighlighted = pageTreeStateUpdatesContainer.state.highlightPagesIds;
            if (highlightedPages.current.length === pagesInTreeHighlighted.length) {
                pageTreeStateUpdatesContainer.clearHighlightedPages();
                highlightedPages.current = [];
            }
        };
        $[1] = pageTreeStateUpdatesContainer;
        $[2] = t2;
    } else t2 = $[2];
    const onPageHighlighted = t2;
    let t3;
    if ($[3] !== onPageHighlighted) {
        t3 = [
            onPageHighlighted
        ];
        $[3] = onPageHighlighted;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
/**
 * This component is what makes the generic `PageTreeController` into a fully functional
 * navigational Page Tree that we all love. It is the one to actually handle things like:
 *  - analytics, performance, and experience tracking events
 *  - backend mutations after drag-n-drop
 *  - orchestrating "undo" for the d-n-d
 *  - showing flags of various kinds (successes/failures). Although triggers for these might originate in other components.
 */ const $a4f80453e05e0dd2$var$PageTreeInner = ({ isInDrawer: isInDrawer = false, onDragDropSuccess: onDragDropSuccess = $a4f80453e05e0dd2$var$noop, onItemClick: onItemClick, isPeekingFromBlogs: isPeekingFromBlogs, isSuperAdmin: isSuperAdmin = false, pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer, flags: flags, setIsPageTreeLoading: setIsPageTreeLoading, setPageTreeError: setPageTreeError = $a4f80453e05e0dd2$var$noop, isHoverPageCardOptedIn: isHoverPageCardOptedIn = false, closeAllHoverPageCards: closeAllHoverPageCards = $a4f80453e05e0dd2$var$noop, isQuickActionsEnabled: isQuickActionsEnabled = false, isInlineRenameEnabled: isInlineRenameEnabled = false, onEnterHoverTarget: onEnterHoverTarget = $a4f80453e05e0dd2$var$noop, onLeaveHoverTarget: onLeaveHoverTarget = $a4f80453e05e0dd2$var$noop, onBlurHoverTarget: onBlurHoverTarget = $a4f80453e05e0dd2$var$noop, shouldRenderAfterIcon: shouldRenderAfterIcon, homepageId: homepageId, setContentTreeSize: setContentTreeSize = $a4f80453e05e0dd2$var$noop, onContentTreeLoadComplete: onContentTreeLoadComplete = $a4f80453e05e0dd2$var$noop })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ spaceKey: spaceKey, contentId: contentId, contentIdLoading: contentIdLoading, routeName: routeName }] = (0, $ep3mz.usePageState)();
    const typeSafeSpaceKey = spaceKey || '';
    // Many analytics callbacks are sending the current viewing page. The problem is these callbacks are passed to every page tree item.
    // If we use contentId directly the callback functions are going to be regenerated and making all page tree items re-render.
    const contentIdForAnalyticsRef = (0, $42omo.useRef)(contentId);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [openQuickActionsId, setOpenQuickActionsId] = (0, $42omo.useState)(null);
    const [focusedQuickActionsId, setFocusedQuickActionsId] = (0, $42omo.useState)(null);
    const { setIsDraggingItem: setIsDraggingItem, getIsDraggingItem: getIsDraggingItem } = (0, $6CrbN.useIsDragging)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isOnEditRouteRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        isOnEditRouteRef.current = isOnEditRoute;
        contentIdForAnalyticsRef.current = contentId;
    }, [
        isOnEditRoute,
        contentId
    ]);
    const renderResourcedEmoji = (0, $42omo.useRef)(false);
    const { onUndoShortcut: onUndoShortcut, showUndoFlag: showUndoFlag, hideLastUndoFlag: hideLastUndoFlag, addUndo: addUndo } = $a4f80453e05e0dd2$var$usePageTreeMoveHistory({
        flags: flags,
        intl: intl,
        createAnalyticsEvent: createAnalyticsEvent,
        spaceKey: spaceKey
    });
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-page-tree-item'
    });
    const { sendInitiatedEvent: sendInitiatedEvent } = (0, $cH0F8.useConsumptionEvents)();
    const visitPage = (0, $42omo.useCallback)((event, page, spaceId, getContentTreeSize)=>{
        const contentTreeSize = getContentTreeSize?.();
        closeAllHoverPageCards?.();
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('clicked', spaceId, //spaceId was already passing Undefined
        isInDrawer, page.data?.status, contentIdForAnalyticsRef.current, page.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current, contentTreeSize, typeSafeSpaceKey)).fire();
        // metaKey = ⌘ in macOS or middle scroll mouse button
        // Use default browser behaviour when any of these key was pressed
        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey || event.button === 1) {
            event.currentTarget.href = (0, $lpPVE.generatePathWithFeatureCodesQueryParam)(event.currentTarget.href, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]);
            return; // let the link's href handle the navigation
        }
        sendInitiatedEvent({
            contentId: page.id,
            spaceKey: typeSafeSpaceKey,
            source: 'PageTree',
            utmSource: 'PAGETREE'
        });
        const url = `${(0, $jlIaF.CONTEXT_PATH)}${page.data?.webui}`;
        const bypassURL = (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: url,
            spaceKey: typeSafeSpaceKey,
            contentType: page?.data?.type,
            editorVersion: page?.data?.editorVersion,
            contentId: page.id
        });
        const isDraft = page.data?.status === 'DRAFT';
        if (isDraft) {
            event.preventDefault();
            event.stopPropagation();
            loadEditor({
                contentId: page.id,
                spaceKey: typeSafeSpaceKey,
                redirectUrl: bypassURL,
                isFabricSupported: page?.data?.editorVersion === 'v2',
                isEmbeddedContent: false
            });
        } else {
            event.preventDefault();
            push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(url, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]));
        }
        if (onItemClick) onItemClick();
    }, [
        push,
        onItemClick,
        typeSafeSpaceKey,
        closeAllHoverPageCards,
        createAnalyticsEvent,
        isInDrawer,
        loadEditor,
        isOnEditRouteRef,
        sendInitiatedEvent
    ]);
    const handleClick = (0, $42omo.useCallback)((event_0, page_0, onExpand, onCollapse, ...args)=>{
        if (page_0.data.type === 'folder') {
            if ((0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false)) {
                // Toggle tree expand/collapse and navigate to folder view
                if (page_0.isExpanded) {
                    onCollapse?.(page_0.id);
                    (0, $4TXTZ.default)('page-tree-item-collapse', event_0.timeStamp);
                } else {
                    onExpand?.(page_0.id);
                    (0, $4TXTZ.default)('page-tree-item-expand', event_0.timeStamp);
                }
            } else {
                event_0.preventDefault();
                page_0.isExpanded ? onCollapse?.(page_0.id) : onExpand?.(page_0.id);
                if (page_0.isExpanded) (0, $4TXTZ.default)('page-tree-item-collapse', event_0.timeStamp);
                else (0, $4TXTZ.default)('page-tree-item-expand', event_0.timeStamp);
                return;
            }
        }
        // Check for storage enforcement before sending users through to draft pages
        const isDraft_0 = page_0.data?.status === 'DRAFT';
        (isDraft_0 ? enforceStorageLimit(visitPage) : visitPage)(event_0, page_0, ...args);
    }, [
        visitPage,
        enforceStorageLimit
    ]);
    const draftText = intl.formatMessage((0, $bP5d8.i18n).untitledDraftText);
    const dragPreview = (0, $42omo.useCallback)((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdzEA.DragPreview), {
            item: item
        }), []);
    const statusesRef = (0, $42omo.useRef)((0, $ivyMZ.PAGE_TREE_STATUSES));
    const [scrollToItem] = $a4f80453e05e0dd2$var$useScrollToItem({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const [onPageHighlighted] = $a4f80453e05e0dd2$var$usePageHighlight({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const publishPageTreeUpdate = (0, $dncjA.useOutboundPageTreeUpdatePublisher)((0, $dncjA.OutboundPageTreeMessage).ContentUpdated);
    const { movePage: movePage } = (0, $55DRn.useMovePageHandler)();
    const [dndError, setDnDError] = (0, $42omo.useState)(null);
    const [initialLoadComplete, setInitialLoadComplete] = (0, $42omo.useState)(false);
    const [initialPageTreeSize, setInitialPageTreeSize] = (0, $42omo.useState)(0);
    const pageTreeWasSSRRendered = (0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    if (!renderResourcedEmoji.current && pageTreeWasSSRRendered) renderResourcedEmoji.current = true;
    const managedOnEnterHoverTarget = (0, $42omo.useCallback)((...args_0)=>{
        // while a drag is occurring, we don't also items to have their hover action triggered
        if (!getIsDraggingItem()) onEnterHoverTarget(...args_0);
    }, [
        onEnterHoverTarget,
        getIsDraggingItem
    ]);
    const editingTitle = pageTreeStateUpdatesContainer.state.editingTitle;
    const isEditingTitleId = editingTitle?.contentId;
    const setIsEditingTitleId = (0, $42omo.useCallback)((pageId)=>{
        return pageTreeStateUpdatesContainer.setIsEditingTitleId(pageId);
    }, [
        pageTreeStateUpdatesContainer
    ]);
    const clearDelete = (0, $42omo.useCallback)(()=>{
        pageTreeStateUpdatesContainer.clearOptimisticDeleteId();
    }, [
        pageTreeStateUpdatesContainer
    ]);
    /**
   * We are registering an "open layer" when the quick actions panel is open, or if we are renaming
   * a page title.
   *
   * This is used to keep the side nav flyout open while the user is renaming a page inline.
   */ (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: Boolean(openQuickActionsId || isEditingTitleId),
        // Providing a noop for now. In the future, we may want to cancel any pending renames when a close
        // signal is received. This will be explored in https://jplat.atlassian.net/browse/BLU-7168
        onClose: $a4f80453e05e0dd2$var$noop
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const renderItem = (0, $42omo.useCallback)((params)=>{
        const { spaceHomePageId: spaceHomePageId, updateSinglePage: updateSinglePage, spaceId: spaceId_0, getContentTreeSize: getContentTreeSize_0, ...renderItemParams } = params;
        return (0, $23e76f192fd1fdb2$export$4240bef965f11267)(renderItemParams, {
            draftText: draftText,
            isSuperAdmin: isSuperAdmin,
            spaceHomePageId: spaceHomePageId,
            onClick: handleClick,
            onExpand: renderItemParams.onExpand,
            onCollapse: renderItemParams.onCollapse,
            spaceKey: typeSafeSpaceKey,
            spaceId: spaceId_0,
            scrollToItem: scrollToItem,
            onPageHighlighted: onPageHighlighted,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            isQuickActionsEnabled: isQuickActionsEnabled,
            isInlineRenameEnabled: isInlineRenameEnabled,
            closeAllHoverPageCards: closeAllHoverPageCards,
            openQuickActionsId: openQuickActionsId,
            setOpenQuickActionsId: setOpenQuickActionsId,
            focusedQuickActionsId: focusedQuickActionsId,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            editingTitle: editingTitle,
            setIsEditingTitleId: setIsEditingTitleId,
            onEnterHoverTarget: managedOnEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            updateSinglePage: updateSinglePage,
            pageTreeWasSSRRendered: pageTreeWasSSRRendered,
            renderResourcedEmoji: renderResourcedEmoji.current,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            hideDraftHrefs: shouldBlockCreate,
            getContentTreeSize: getContentTreeSize_0,
            renderServerPlaceholder: renderServerPlaceholder
        });
    }, [
        draftText,
        isSuperAdmin,
        handleClick,
        scrollToItem,
        typeSafeSpaceKey,
        onPageHighlighted,
        isHoverPageCardOptedIn,
        isQuickActionsEnabled,
        isInlineRenameEnabled,
        closeAllHoverPageCards,
        openQuickActionsId,
        focusedQuickActionsId,
        editingTitle,
        setIsEditingTitleId,
        managedOnEnterHoverTarget,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        pageTreeWasSSRRendered,
        shouldRenderAfterIcon,
        renderResourcedEmoji,
        shouldBlockCreate,
        renderServerPlaceholder
    ]);
    (0, $42omo.useEffect)(()=>{
        if (pageTreeWasSSRRendered) //set FMP now if SSR rendered and we didn't skip pageTree rendering
        (0, $1q7H7.PAGE_TREE_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, [
        pageTreeWasSSRRendered
    ]);
    const onLoadError = (0, $42omo.useCallback)((apolloError, options)=>{
        flags.showErrorFlag({
            title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
            description: location ? intl.formatMessage((0, $bP5d8.i18n).paginateErrorDescription) : intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
            isAutoDismiss: true
        });
        if (options?.isExpected) // This is a temporary measure as we gradually improve PageTree error handling.
        // Normally expected errors should not render a generic error component and
        // instead should provide an error-specific experience.
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        else {
            setPageTreeError(apolloError);
            experienceTracker.stopOnError({
                name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
                attributes: {
                    location: options?.location || 'main'
                },
                error: apolloError
            });
        }
    }, [
        flags,
        intl,
        experienceTracker,
        setPageTreeError
    ]);
    const onPageMove = (0, $42omo.useCallback)((moveParams, { contentStatus: contentStatus, movedPageTitle: movedPageTitle, spaceId: spaceId_1, source: source, destination: destination, instructionType: instructionType, revertMove: revertMove })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(true)).fire();
        const handleDragDropSuccess = (spaceId_2, pageId_0, sourceParentId, destinationParentId, instructionType_0, isAmnPage = false)=>{
            createAnalyticsEvent((0, $88DkZ.dragDropEndTrackEvent)({
                source: 'PageTree',
                contentStatus: contentStatus,
                pageId: pageId_0,
                previousParentPageId: sourceParentId,
                newParentPageId: destinationParentId,
                previousSpaceId: spaceId_2,
                newSpaceId: spaceId_2,
                isOnEditRoute: isOnEditRouteRef.current,
                instructionType: instructionType_0,
                isAmnPage: isAmnPage
            })).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
            });
            publishPageTreeUpdate({
                contentId: pageId_0,
                parentId: destinationParentId
            });
            onDragDropSuccess(pageId_0);
        };
        const handleDndError = (apolloError_0)=>{
            // undo the move in state so that the tree reflects that the move did not succeed
            revertMove();
            if (!apolloError_0) return;
            const i18nMessage = (0, $6FfmH.getI18nMessageForKnownError)(apolloError_0);
            if (i18nMessage !== undefined) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError_0);
                flags.showErrorFlag({
                    title: i18nMessage.title.defaultMessage,
                    description: i18nMessage.description.defaultMessage,
                    isAutoDismiss: true
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    attributes: {
                        expectedErrorDescription: i18nMessage.description.defaultMessage
                    }
                });
            } else if ($a4f80453e05e0dd2$var$isMovePagePermissionError(apolloError_0)) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError_0);
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'User lacks move permissions'
                });
            } else {
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    error: apolloError_0
                });
            }
            setDnDError(apolloError_0);
        };
        const makeMovePageRequests = async (movePageParams, onMovePageSuccess)=>{
            // Use allSettled as failures from getAutomatedMeetingNotesPageProperties should not result in a movePage failure
            const [movePageResult, amnPagePropsResult] = await Promise.allSettled([
                movePage(movePageParams).then(onMovePageSuccess),
                (0, $6g38M.getAutomatedMeetingNotesPageProperties)(movePageParams.pageId)
            ]);
            if (movePageResult.status === 'rejected') throw movePageResult.reason;
            const isAmnPage_0 = amnPagePropsResult.status === 'fulfilled' ? amnPagePropsResult.value.isAMN : undefined;
            return {
                movePageResult: movePageResult.value,
                isAmnPage: isAmnPage_0
            };
        };
        const reverseMove = ()=>{
            const reverseMoveParams = revertMove();
            makeMovePageRequests(reverseMoveParams).then(({ isAmnPage: isAmnPage_1 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, // If the move is reversed, the source will be the original destination
                // and the destination will be the original source.
                destination.parentId, source.parentId, instructionType, isAmnPage_1)).catch(handleDndError);
        };
        addUndo({
            undo: reverseMove
        });
        makeMovePageRequests(moveParams, ()=>showUndoFlag(movedPageTitle)).then(({ isAmnPage: isAmnPage_2 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, source.parentId, destination.parentId, instructionType, isAmnPage_2)).catch(handleDndError);
    }, [
        experienceTracker,
        flags,
        intl,
        addUndo,
        movePage,
        showUndoFlag,
        createAnalyticsEvent,
        onDragDropSuccess,
        isOnEditRouteRef,
        publishPageTreeUpdate
    ]);
    const forceFetchedCallback = (0, $42omo.useCallback)((state)=>{
        const lastForceFetchId = pageTreeStateUpdatesContainer.state.forceFetchPageId;
        pageTreeStateUpdatesContainer.clearForceFetch();
        const newContentId = editingTitle?.contentId;
        // For paginated page trees, force fetch id of the newly created content if the content does not
        // have a create content route. This will enable properly scrolling to the new item
        if ((state.isTreeTruncatedFollowing || state.isTreeTruncatedPrevious) && editingTitle?.isNewContent && lastForceFetchId !== newContentId) pageTreeStateUpdatesContainer.forceFetchWithInlineRename(newContentId, newContentId);
    }, [
        pageTreeStateUpdatesContainer,
        editingTitle
    ]);
    const onMoveInvalid = (0, $42omo.useCallback)(({ reason: reason })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(false)).fire();
        const showLargePageTreeFlag = ()=>{
            flags.showWarningFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeDescription),
                actions: [
                    {
                        content: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeSettingsAction),
                        onClick: ()=>{
                            push(`/wiki/pages/reorderpages.action?key=${spaceKey}`);
                        }
                    },
                    {
                        content: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeRefreshAction),
                        onClick: ()=>window.location.reload()
                    }
                ],
                isAutoDismiss: true
            });
        };
        const showInvalidMoveDraftFlag = ()=>{
            flags.showErrorFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftDescription),
                isAutoDismiss: true
            });
        };
        const showInvalidMoveManagedFolderFlag = ()=>{
            flags.showErrorFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveManagedFolderTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveManagedFolderDescription),
                isAutoDismiss: true
            });
        };
        switch(reason){
            case 'TREE_TOO_LARGE':
                showLargePageTreeFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Large page tree limit exceeded'
                });
                break;
            case 'INVALID_MOVE_LOCATION':
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location'
                });
                break;
            case 'INVALID_MOVE_LOCATION_DRAFT':
                showInvalidMoveDraftFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location onto draft'
                });
                break;
            case 'INVALID_MOVE_LOCATION_MANAGED_FOLDER':
                showInvalidMoveManagedFolderFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move involving managed folder'
                });
                break;
        }
    }, [
        createAnalyticsEvent,
        experienceTracker,
        flags,
        intl,
        push,
        spaceKey
    ]);
    const onDragStart = (0, $42omo.useCallback)(()=>{
        closeAllHoverPageCards();
        setOpenQuickActionsId(null);
        createAnalyticsEvent((0, $88DkZ.dragStartUIEvent)()).fire();
        experienceTracker.start({
            name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
        });
        hideLastUndoFlag();
    }, [
        createAnalyticsEvent,
        experienceTracker,
        hideLastUndoFlag,
        closeAllHoverPageCards
    ]);
    const expandAnalyticsCallback = (0, $42omo.useCallback)((page_1, { spaceId: spaceId_3 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('expanded', spaceId_3, isInDrawer, page_1.data?.status, contentIdForAnalyticsRef.current, page_1.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current)).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef
    ]);
    const collapseAnalyticsCallback = (0, $42omo.useCallback)((page_2, { spaceId: spaceId_4 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('collapsed', spaceId_4, isInDrawer, page_2.data?.status, contentIdForAnalyticsRef.current, page_2.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current)).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef
    ]);
    const isDraggable = (0, $42omo.useCallback)((item_0, { space: space })=>{
        if (item_0.id === isEditingTitleId) return false;
        return $a4f80453e05e0dd2$var$canMoveInSpace(space);
    }, [
        isEditingTitleId
    ]);
    const onLoadMore = (0, $42omo.useCallback)((pagesCount, spaceId_5, direction)=>{
        createAnalyticsEvent((0, $88DkZ.pageTreePaginationEvent)(spaceId_5, pagesCount, 'containerNavigation', direction)).fire();
    }, [
        createAnalyticsEvent
    ]);
    /**
   * onInitialLoadComplete is called after the first initial load of the page tree's data. This includes refreshing the page.
   * It does not include returning from blog peek, transitioning from blog BACK to page tree, transitioning amongst pages in page tree, etc.
   */ const onInitialLoadComplete = (0, $42omo.useCallback)((pagetreeSize)=>{
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: 'NavigationLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationView),
            subjectId: 'SpaceViewLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        onContentTreeLoadComplete(); // show blog tree spotlight only after page tree finishes loading to prevent misplaced spotlight
        if (pagetreeSize && pagetreeSize > 2) setInitialPageTreeSize(pagetreeSize - 2); //subtract 2 for VIRTUAL_LOCAL_ROOT_ID and VIRTUAL_ROOT_ID
        setInitialLoadComplete(true);
    }, [
        experienceTracker,
        spaceKey,
        onContentTreeLoadComplete
    ]);
    const currentPageId = pageTreeStateUpdatesContainer.state.forceFetchPageId || (isPeekingFromBlogs ? homepageId : contentId);
    const isCreateContentRoute = routeName === (0, $1NBp8.CREATE_CONTENT).name;
    // Note: content id can be null even when contentIdLoading = false
    // Because a space may not have homepage
    const showPageTree = Boolean(contentId) || !contentIdLoading;
    if (!showPageTree) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        key: `experience-${spaceKey}`,
        name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
        id: spaceKey
    }), dndError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: dndError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNDO_SHORTCUT),
        listener: onUndoShortcut
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUMkS.PageTreeCoordinator), {
        // CONFCLOUD-69158 The key here is forcing page tree to re-mount when switching from space to space
        // This preventing issue when transition from a space that has homepage to a space without
        key: spaceKey,
        statuses: statusesRef.current,
        isPeekingFromBlogs: isPeekingFromBlogs,
        onPageMove: onPageMove,
        onDragStart: onDragStart,
        onMoveInvalid: onMoveInvalid,
        onLoadError: onLoadError,
        onExpand: expandAnalyticsCallback,
        onCollapse: collapseAnalyticsCallback,
        onLoadMore: onLoadMore,
        onInitialLoadComplete: onInitialLoadComplete,
        currentPageId: currentPageId,
        highlightPages: pageTreeStateUpdatesContainer.state.highlightPagesIds,
        forceFetchCurrentPage: Boolean(pageTreeStateUpdatesContainer.state.forceFetchPageId),
        forceFetchedCallback: forceFetchedCallback,
        optimisticDeleteId: pageTreeStateUpdatesContainer.state.optimisticDeletePageId || undefined,
        clearDeleteId: clearDelete,
        spaceKey: typeSafeSpaceKey,
        renderItem: renderItem,
        dragPreview: dragPreview,
        isDraggable: isDraggable,
        setIsPageTreeLoading: setIsPageTreeLoading,
        isSuperAdmin: isSuperAdmin,
        getIsDraggingItem: getIsDraggingItem,
        setIsDraggingItem: setIsDraggingItem,
        setOpenQuickActionsId: setOpenQuickActionsId,
        renderResourcedEmoji: renderResourcedEmoji.current,
        setContentTreeSize: setContentTreeSize,
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
        isCreateContentRoute: isCreateContentRoute,
        flags: flags
    }), (initialLoadComplete || undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC),
        customData: {
            initialPageTreeSize: initialPageTreeSize,
            skipTreeRenderSSR: !pageTreeWasSSRRendered //tracks if Best effort failed & if tree was over 200 pages
        },
        stopTime: pageTreeWasSSRRendered ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined
    })));
};
const $a4f80453e05e0dd2$export$73500bf5f2e2b0c4 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4f80453e05e0dd2$var$PageTreeInner, {
                    ...props,
                    pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
                    flags: flags
                }))));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
$a4f80453e05e0dd2$export$73500bf5f2e2b0c4.displayName = 'PageTree';
module.exports["PageTree"] = $a4f80453e05e0dd2$export$73500bf5f2e2b0c4;

});

parcelRegister("qeApQ", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $bRRFB = parcelRequire("bRRFB");


var $d6TaN = parcelRequire("d6TaN");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $04edbe5e5395e00f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$bRRFB(collection)) {
            var iteratee = $hWvFC(predicate, 3);
            collection = $d6TaN(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $04edbe5e5395e00f$var$createFind;

});

parcelRegister("haupJ", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $hWvFC = parcelRequire("hWvFC");


var $ehlgT = parcelRequire("ehlgT");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $c7faf66d496f60a0$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c7faf66d496f60a0$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $ehlgT(fromIndex);
    if (index < 0) index = $c7faf66d496f60a0$var$nativeMax(length + index, 0);
    return $kQ62s(array, $hWvFC(predicate, 3), index);
}
module.exports = $c7faf66d496f60a0$var$findIndex;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("cH0F8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $04e9M = parcelRequire("04e9M");


var $6ggfK = parcelRequire("6ggfK");


var $iYrVi = parcelRequire("iYrVi");


var $a2hNG = parcelRequire("a2hNG");

const $99b9dc495b87cac6$export$2fc805631456aefd = ()=>{
    const { sendEvent: sendEvent } = (0, $6ggfK.useSendAnalyticsEvents)();
    const dwellTimeHelperRef = (0, $42omo.useRef)(null);
    const sendErrorEvent = (0, $42omo.useCallback)((errorMessage, data)=>{
        const unifiedErrorEvent = (0, $a2hNG.createConsumptionErrorEvent)(errorMessage, data);
        sendEvent(unifiedErrorEvent);
    }, [
        sendEvent
    ]);
    const sendInitiatedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionInitiatedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        sendErrorEvent,
        sendEvent
    ]);
    const sendViewedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        sendErrorEvent,
        sendEvent
    ]);
    const sendCompletedEvent = (0, $42omo.useCallback)((event, dwellTimeHelperData)=>{
        if (dwellTimeHelperData.attributes.finalDwellEvent) {
            const consumptionCompletedEvent = (0, $a2hNG.createConsumptionCompletedEvent)(event, dwellTimeHelperData, document.visibilityState);
            sendEvent(consumptionCompletedEvent, true);
        }
    }, [
        sendEvent
    ]);
    const sendViewedEventAndCompletedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        const sendEventPromise = (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
            return event;
        });
        Promise.all([
            sendEventPromise,
            (0, $04e9M.getDwellTimeHelper)()
        ]).then(([event, DwellTimeHelper])=>{
            const dwellTimeHelper = new DwellTimeHelper((callbackData)=>sendCompletedEvent(event, callbackData), event.data);
            dwellTimeHelper.start();
            dwellTimeHelperRef.current = dwellTimeHelper;
        }).catch((error)=>{
            sendErrorEvent(error.message, data);
        });
    }, [
        sendEvent,
        sendCompletedEvent,
        sendErrorEvent
    ]);
    const stopDwellTimeTracker = (0, $42omo.useCallback)(()=>{
        if (dwellTimeHelperRef.current) dwellTimeHelperRef.current.stop();
    }, []);
    return {
        sendInitiatedEvent: sendInitiatedEvent,
        sendViewedEvent: sendViewedEvent,
        sendViewedEventAndCompletedEvent: sendViewedEventAndCompletedEvent,
        sendCompletedEvent: sendCompletedEvent,
        sendErrorEvent: sendErrorEvent,
        stopDwellTimeTracker: stopDwellTimeTracker
    };
};
module.exports["useConsumptionEvents"] = $99b9dc495b87cac6$export$2fc805631456aefd;

});

parcelRegister("6ggfK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $37a7b14bbef74679$export$ba826f94d4d18f90 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendEvent = (0, $42omo.useCallback)((event, skipVisibilityCheck = false)=>{
        if (document.visibilityState === 'hidden' && !skipVisibilityCheck) document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') createAnalyticsEvent(event).fire();
        }, {
            once: true
        });
        else createAnalyticsEvent(event).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendEvent: sendEvent
    };
};
module.exports["useSendAnalyticsEvents"] = $37a7b14bbef74679$export$ba826f94d4d18f90;

});

parcelRegister("iYrVi", function(module, exports) {

var $45kl0 = parcelRequire("45kl0");


var $c0rhi = parcelRequire("c0rhi");

const $515f7b87fcfa6100$export$22490ad3617f1d6c = async (spaceKey, contentId)=>{
    if (!contentId) return Promise.reject(new Error('Content ID is required'));
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $45kl0.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId
        },
        __callerPackage__: "@confluence/unified-analytics"
    });
    // this is a workaround to handle the case where the content is restricted
    if (!response.error && response?.data?.singleContent === null) return Promise.reject('singleContent is null');
    return response;
};
module.exports["loadSpaceAndContentData"] = $515f7b87fcfa6100$export$22490ad3617f1d6c;

});

parcelRegister("45kl0", function(module, exports) {
/**
 * @generated SignedSource<<d12067b02877fa466cec60e87527b029>>
 * @relayHash c95a5f84d5e59d796094fd4369b29459
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6
const $735d6368c1baed2b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getConsumptionEventDataQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getConsumptionEventDataQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "c95a5f84d5e59d796094fd4369b29459",
            "id": "1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6",
            "metadata": {},
            "name": "getConsumptionEventDataQuery",
            "operationKind": "query",
            "text": "query getConsumptionEventDataQuery($spaceKey:String!,$contentId:ID!){space(key:$spaceKey){id,type,status},singleContent(id:$contentId){id,status,type,subType}}"
        }
    };
}();
$735d6368c1baed2b$var$node.hash = "a468aeb5b2dd43bd9bd81e0a81d18bda";
var $735d6368c1baed2b$export$2e2bcd8739ae039 = $735d6368c1baed2b$var$node;
module.exports["default"] = $735d6368c1baed2b$export$2e2bcd8739ae039;

});

parcelRegister("a2hNG", function(module, exports) {
const $d12dabfe6ca737c1$export$1931aa92cd9ee803 = (status, contentState)=>{
    if (contentState) return contentState;
    switch(status){
        case 'current':
            return 'published';
        case 'archived':
            return 'archived';
        case 'draft':
            return 'draft';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$3f4d5492ecb52ee5 = (subType, contentMode)=>{
    if (contentMode) return contentMode;
    switch(subType){
        case 'live':
            return 'live';
        case 'embed':
            return 'embedded';
        default:
            return 'classic';
    }
};
const $d12dabfe6ca737c1$export$5e059cd6f8a921d7 = (type, contentType)=>{
    if (contentType) return contentType;
    switch(type){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blogpost';
        case 'whiteboard':
            return 'whiteboard';
        case 'slide':
            return 'slide';
        case 'database':
            return 'database';
        case 'embed':
            return 'smartlink';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$6d76e0936bf44cc2 = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data?.space?.id ?? 'unset',
                contentId: response?.data?.singleContent?.id ?? 'unset'
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b4ddea3e5241109a = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'initiated',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data?.space?.id ?? 'unset',
                contentId: response?.data?.singleContent?.id ?? 'unset',
                utmSource: data.utmSource
            }
        }
    };
};
const $d12dabfe6ca737c1$export$ea5bf29fc7b309b8 = (event, dwellTimeHelperData, visibilityState)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            ...event.data,
            action: 'completed',
            attributes: {
                ...event.data.attributes,
                dwellTime: dwellTimeHelperData.attributes.dwellTime,
                pageVisibility: visibilityState
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b2d32ef04e5142a1 = (errorMessage, props)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'error',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: props.source,
            attributes: {
                error: errorMessage,
                contentId: props.contentId ?? 'unset',
                spaceKey: props.spaceKey
            }
        }
    };
};
module.exports["createConsumptionViewedEvent"] = $d12dabfe6ca737c1$export$6d76e0936bf44cc2;
module.exports["createConsumptionInitiatedEvent"] = $d12dabfe6ca737c1$export$b4ddea3e5241109a;
module.exports["createConsumptionCompletedEvent"] = $d12dabfe6ca737c1$export$ea5bf29fc7b309b8;
module.exports["createConsumptionErrorEvent"] = $d12dabfe6ca737c1$export$b2d32ef04e5142a1;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("hFuXC"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("hFuXC", function(module, exports) {

let $cdce481da9c47d1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdce481da9c47d1c$var$load("e1RjR"),
    $cdce481da9c47d1c$var$load("hhss7"),
    $cdce481da9c47d1c$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("dncjA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

var $42d2cbe129156e29$export$a35ea3343c58b478 = /*#__PURE__*/ function(OutboundPageTreeMessage) {
    OutboundPageTreeMessage[OutboundPageTreeMessage["ContentUpdated"] = 0] = "ContentUpdated";
    return OutboundPageTreeMessage;
}({});
class $42d2cbe129156e29$var$OutboundPageTreeMessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        if (!this.subscribers[type]) return;
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $42d2cbe129156e29$var$outboundPageTreeBus = new $42d2cbe129156e29$var$OutboundPageTreeMessageBus();
const $42d2cbe129156e29$export$6aa2f5cad92d6f47 = (type)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $42d2cbe129156e29$export$4a84af3f2bf2e18a = (type, callback)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.subscribe(type, callback);
            return ()=>{
                $42d2cbe129156e29$var$outboundPageTreeBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
};
module.exports["OutboundPageTreeMessage"] = $42d2cbe129156e29$export$a35ea3343c58b478;
module.exports["useOutboundPageTreeUpdatePublisher"] = $42d2cbe129156e29$export$6aa2f5cad92d6f47;
module.exports["useOutboundPageTreeUpdateSubscriber"] = $42d2cbe129156e29$export$4a84af3f2bf2e18a;

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "@confluence/storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<ce267d56c5b6d7a41b23a639614e5b9e>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
} /**
   * Returns `true` if any of the dimension(s) being animated have changed
   * between the previous and next measurements.
   */ 
function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
} /**
   * Returns the CSS `transition-property` / `will-change` value for the
   * given dimension(s).
   */ 
function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
} /**
   * `useResizing` animates dimension changes (width, height, or both) over state changes.
   * If the relevant dimension(s) haven't changed nothing will happen.
   *
   * Pass `dimension: 'width' | 'height' | 'both'` to choose which axis (or axes) to animate.
   *
   * __WARNING__: Potentially janky. This hook animates layout-affecting properties which are
   * [notoriously unperformant](https://firefox-source-docs.mozilla.org/performance/bestpractices.html#Get_familiar_with_the_pipeline_that_gets_pixels_to_the_screen).
   * Test your app over low powered devices, you may want to avoid this if you can see it impacting FPS.
   */ 
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
         // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration); // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("l1uFv", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    if ((0, $iffSy.isRelayEnabled)(params.__callerPackage__)) return $65c7b8940c778902$var$readQueryInteropRelay(params);
    else return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    // Guard window for SSR; this only runs client-side.
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) return null;
    const source = relayEnv.getStore().getSource();
    const rootRecord = source.get((0, $3e6Uc.ROOT_ID));
    if (!rootRecord) return null;
    const queryNode = params.query;
    const queryFields = queryNode?.operation?.selections;
    if (!queryFields) return null;
    const variables = params.variables ?? {};
    return $65c7b8940c778902$var$readFields(source, (0, $3e6Uc.ROOT_ID), queryFields, variables);
}
function $65c7b8940c778902$var$resolveArgValue(arg, variables) {
    if (arg.kind === 'Literal') return arg.value;
    if (arg.kind === 'Variable') return variables[arg.variableName];
    // Fallback for other argument types
    return arg.value;
}
function $65c7b8940c778902$var$getFieldKey(field, variables) {
    // Relay pre-computes `storageKey` for literal-only args; prefer it when present.
    if (field.storageKey) return field.storageKey;
    if (!field.args || field.args.length === 0) return field.name;
    // Mirror Relay's `formatStorageKey` (relay-runtime/store/RelayStoreUtils): sort args
    // alphabetically and omit any with a null/undefined value. Skipping the omission would
    // reconstruct a key Relay never wrote (e.g. `teamType:null`), so the lookup misses and
    // the field reads back as `null`.
    const sortedArgs = field.args.slice().sort((a, b)=>a.name.localeCompare(b.name));
    const formattedArgs = [];
    for (const arg of sortedArgs){
        const value = $65c7b8940c778902$var$resolveArgValue(arg, variables);
        if (value != null) formattedArgs.push(`${arg.name}:${JSON.stringify(value)}`);
    }
    return formattedArgs.length === 0 ? field.name : `${field.name}(${formattedArgs.join(',')})`;
}
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readFields(source, recordId, fields, variables) {
    const record = source.get(recordId);
    if (!record) return null;
    const data = {};
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Handle @include/@skip directives with variables
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) {
                const conditionalData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
                if (conditionalData) Object.assign(data, conditionalData);
            }
        } else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(linkedField, variables);
            const linkedRef = record[fieldKey];
            if (linkedField.plural) {
                // Relay stores plural refs in two shapes:
                //  - canonical: { __refs: ['id1', 'id2', ...] }
                //  - tolerated: [{ __ref: 'id1' }, { __ref: 'id2' }]
                if (linkedRef && typeof linkedRef === 'object' && !Array.isArray(linkedRef) && Array.isArray(linkedRef.__refs)) {
                    const refs = linkedRef.__refs;
                    data[linkedField.name] = refs.map((id)=>id ? $65c7b8940c778902$var$readFields(source, id, linkedField.selections, variables) : null);
                } else if (Array.isArray(linkedRef)) data[linkedField.name] = linkedRef.map((ref)=>{
                    if (ref && typeof ref === 'object' && '__ref' in ref) return $65c7b8940c778902$var$readFields(source, ref.__ref, linkedField.selections, variables);
                    return null;
                });
                else data[linkedField.name] = null;
            } else if (linkedRef && typeof linkedRef === 'object' && '__ref' in linkedRef) data[linkedField.name] = $65c7b8940c778902$var$readFields(source, linkedRef.__ref, linkedField.selections, variables);
            else data[linkedField.name] = null;
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(scalarField, variables);
            data[scalarField.name] = record[fieldKey];
        } else if (field.kind === 'InlineFragment') {
            // Process all inline fragment selections
            const inlineData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
            if (inlineData) Object.assign(data, inlineData);
        }
    // Other selection kinds (e.g., FragmentSpread, ClientExtension) are ignored —
    // readQuery only needs to traverse what the query operation directly selects.
    }
    return data;
}
/* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<ed1da0f487d4ec7fd1c400d04bb2ada3>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<00faa284694db21a3e13849cb62f2bdf>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<6ad365f1ccfb596256d27d51fa6c0d6c>>
 * @relayHash 40e147f795d6ae695dc2af4dc7df056c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "40e147f795d6ae695dc2af4dc7df056c",
            "id": "689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "9ca5cb64b6d53c6754a4b7af001ba098";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("lY1lm", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cd81aae1dd865317$export$56ef5168f507b51a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6xpDa",
    name: "TreeMonitorLoader",
    loader: async ()=>(await (parcelRequire("1ewPd"))).TreeMonitor
});
module.exports["TreeMonitorLoader"] = $cd81aae1dd865317$export$56ef5168f507b51a;

});

parcelRegister("1ewPd", function(module, exports) {

let $0e608fa17fe2b2e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e608fa17fe2b2e2$var$load("f9QHk").then(()=>parcelRequire('e14IX'));

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("aqBZ0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $42omo.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null)));
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.rect
        ])
    }), icon));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $42omo.createElement("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("f9yl5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $a1WXB = parcelRequire("a1WXB");


var $eIleF = parcelRequire("eIleF");


var $l3dur = parcelRequire("l3dur");


var $dh538 = parcelRequire("dh538");


var $4T4vf = parcelRequire("4T4vf");

parcelRequire("882hS");
var $85Mv7 = parcelRequire("85Mv7");

parcelRequire("afUmf");
var $3ts5j = parcelRequire("3ts5j");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $226XV = parcelRequire("226XV");

var $ba441b9d4456e512$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $ba441b9d4456e512$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $ba441b9d4456e512$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $ba441b9d4456e512$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $ba441b9d4456e512$var$idleState = {
    type: 'idle'
};
const $ba441b9d4456e512$var$draggingState = {
    type: 'dragging'
};
const $ba441b9d4456e512$var$styles = {
    preview: "_1reo15vq _18m915vq _2rko12b0 _1rjc1b66 _18zru2gc _1dqonqa1 _1h6d1l7x _bfhkvuon _p12fgx0z _16qs130s",
    previewText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    draggableBlock: "_80om1qgj"
};
const $ba441b9d4456e512$var$previewIconStyles = null;
const $ba441b9d4456e512$var$draggableInlineStyles = null;
function $ba441b9d4456e512$var$SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ba441b9d4456e512$var$styles.preview
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.075"
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: iconUrl,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsbpxbi _4t3ipxbi _1o9zidpf"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $ba441b9d4456e512$var$styles.previewText
    }, title || url)));
}
function $ba441b9d4456e512$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $226XV.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
}
/**
 * Inner component that handles the actual drag behavior.
 * Must be rendered within a SmartCardProvider context.
 */ function $ba441b9d4456e512$var$SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $42omo.useRef)(null);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const [state, setState] = (0, $42omo.useState)($ba441b9d4456e512$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $42omo.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details);
                const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $a1WXB.extractSmartLinkTitle)(details);
                const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                (0, $3ts5j.setCustomNativeDragPreview)({
                    getOffset: (0, $85Mv7.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title,
                            iconUrl: iconUrl
                        });
                        return ()=>setState($ba441b9d4456e512$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($ba441b9d4456e512$var$draggingState),
            onDrop: ()=>setState($ba441b9d4456e512$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $fFa3V.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $4T4vf.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        "data-testid": "smart-link-draggable-inline",
        "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
        className: (0, $gMc0m.default)([
            "_80om1qgj _1e0c1nu9"
        ])
    }, children), preview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: ref,
        xcss: $ba441b9d4456e512$var$styles.draggableBlock,
        testId: "smart-link-draggable-block"
    }, children), preview);
}
function $ba441b9d4456e512$export$c67c8f76ce4436c({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $l3dur.isSafeUrl)(url) || !(0, $dh538.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba441b9d4456e512$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget
    }, children);
}
module.exports["SMART_LINK_DRAG_TYPES"] = $ba441b9d4456e512$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $ba441b9d4456e512$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $ba441b9d4456e512$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $ba441b9d4456e512$export$c67c8f76ce4436c;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");


var $hSdmP = parcelRequire("hSdmP");


var $j4IDJ = parcelRequire("j4IDJ");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $j4IDJ.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $j4IDJ.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hSdmP.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f7qXf.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $j4IDJ.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("aDQuI", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $hWvFC = parcelRequire("hWvFC");


var $9JSQw = parcelRequire("9JSQw");


var $ghltV = parcelRequire("ghltV");


var $bVtKl = parcelRequire("bVtKl");


var $apAFY = parcelRequire("apAFY");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $7bf644369363a294$var$unionBy = $9JSQw(function(arrays) {
    var iteratee = $apAFY(arrays);
    if ($bVtKl(iteratee)) iteratee = undefined;
    return $ghltV($8jC8i(arrays, 1, $bVtKl, true), $hWvFC(iteratee, 2));
});
module.exports = $7bf644369363a294$var$unionBy;

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("hHyea", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $5ukOg = parcelRequire("5ukOg");


var $dFnBO = parcelRequire("dFnBO");


var $bcPN2 = parcelRequire("bcPN2");

/** Used as the size to enable large array optimizations. */ var $ce3100b697e139b9$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $ce3100b697e139b9$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $7LQYo, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $5ukOg(values, $dFnBO(iteratee));
    if (comparator) {
        includes = $lkNSx;
        isCommon = false;
    } else if (values.length >= $ce3100b697e139b9$var$LARGE_ARRAY_SIZE) {
        includes = $bcPN2;
        isCommon = false;
        values = new $jcOUW(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $ce3100b697e139b9$var$baseDifference;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("jJDs8", function(module, exports) {

var $fYKLM = parcelRequire("fYKLM");

// using a symbol so we can guarantee a key with a unique value
const $b7b680fbf5b4f84f$var$uniqueKey = Symbol('tree-item-instruction');
function $b7b680fbf5b4f84f$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $b7b680fbf5b4f84f$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $b7b680fbf5b4f84f$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $b7b680fbf5b4f84f$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $b7b680fbf5b4f84f$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $b7b680fbf5b4f84f$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $fYKLM.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $b7b680fbf5b4f84f$var$memoizeInstruction = (0, $fYKLM.stable)($b7b680fbf5b4f84f$var$areInstructionsEqual);
function $b7b680fbf5b4f84f$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $b7b680fbf5b4f84f$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $b7b680fbf5b4f84f$var$getInstruction(rest);
    const withBlock = $b7b680fbf5b4f84f$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $b7b680fbf5b4f84f$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$b7b680fbf5b4f84f$var$uniqueKey]: memoized
    };
}
function $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8(userData) {
    return userData[$b7b680fbf5b4f84f$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $b7b680fbf5b4f84f$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8;

});

parcelRegister("fYKLM", function(module, exports) {
function $440eac8f72738c8c$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $440eac8f72738c8c$export$3f55479a3469259f(isEqual = $440eac8f72738c8c$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["isShallowEqual"] = $440eac8f72738c8c$export$2225b4c39d37f8b3;
module.exports["stable"] = $440eac8f72738c8c$export$3f55479a3469259f;

});

parcelRegister("ft7TS", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aTio4 = parcelRequire("aTio4");


var $2n8po = parcelRequire("2n8po");

function $51f217e12c7a77e2$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aTio4.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $51f217e12c7a77e2$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $51f217e12c7a77e2$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $51f217e12c7a77e2$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}
module.exports["DropIndicator"] = $51f217e12c7a77e2$export$62ed72bc21f6b8a6;

});

parcelRegister("aTio4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8Mgg9 = parcelRequire("8Mgg9");


var $9JSVA = parcelRequire("9JSVA");

function $f32cc2f93c269bf0$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Mgg9.Border), {
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$f32cc2f93c269bf0$export$2e2bcd8739ae039 = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;

});

parcelRegister("8Mgg9", function(module, exports) {
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $e9c9b85493bf64c6$var$styles = null;
function $e9c9b85493bf64c6$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $gMc0m.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
} // For React.lazy
var $e9c9b85493bf64c6$export$2e2bcd8739ae039 = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;
module.exports["Border"] = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;

});

parcelRegister("lvOsp", function(module, exports) {

var $diswb = parcelRequire("diswb");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $9x4nt = parcelRequire("9x4nt");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__)) // eslint-disable-next-line react-hooks/rules-of-hooks -- branch stable per build
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    // eslint-disable-next-line react-hooks/rules-of-hooks -- branch stable per build
    return (0, $diswb.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
}
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $irOoi.useRelayEnvironment)();
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__);
    const hookContext = options?.context;
    const initialFetchPolicy = options?.fetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.fetchPolicy) : undefined;
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [called, setCalled] = (0, $42omo.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $42omo.useState)(hookVariables);
    const isMountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $42omo.useEffect)(()=>{
        if (!called) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $3e6Uc.createOperationDescriptor)((0, $3e6Uc.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            if (isMountedRef.current && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $42omo.useRef)(0);
    const fetchMoreIdRef = (0, $42omo.useRef)(0);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const operationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $42omo.useEffect)(()=>{
        if (called && loading) return ufoContext?.hold(operationName);
    }, [
        called,
        loading,
        operationName,
        ufoContext
    ]);
    const execute = (0, $42omo.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }).toPromise().then((result)=>{
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                setData(result);
                setError(undefined);
                onCompleted(result);
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            onError(err);
        }).catch((rawErr)=>{
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            onError(err);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        onCompleted,
        onError
    ]);
    const fetchMore = (0, $42omo.useCallback)((fetchMoreOpts)=>{
        const variables = {
            ...activeVarsRef.current,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // onError gated by isStillCurrent (matches execute); re-throw for Apollo's contract.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
                onError(err);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        onError
    ]);
    // Lazy hooks don't auto-poll; no-op for Apollo signature parity.
    const stopPolling = (0, $42omo.useCallback)(()=>{}, []);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $42omo.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]);
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $1Whri.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_4t3i1osq _1bsb1osq"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        },
        __callerPackage__: "@confluence/automated-meeting-notes"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<11b231cd6c02553d35cade7f32b48a2a>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("kSPGK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $frIzR.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "@confluence/restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "@confluence/restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<54b68d5aa1c95b977f0cb84ddd5a4477>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $eG1e2 = parcelRequire("eG1e2");


var $5tmwS = parcelRequire("5tmwS");


var $g5QRf = parcelRequire("g5QRf");


var $e0ycV = parcelRequire("e0ycV");


var $5YfNL = parcelRequire("5YfNL");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: // can override default icon color
spacing, type: type, isExpanded: isExpanded = false, isMarkdownMode: isMarkdownMode = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        slide: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: isMarkdownMode ? (0, $5YfNL.PageMarkdownIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["toContentTreeType"] = $a8768b1a0c8c67c8$export$204659eac14d740b;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});

parcelRegister("a6VRS", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Custom icon for a managed (synced) open folder.
 * Renders an open folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $6b5b62a1c1d5201a$export$d5c72b0cf938803f = ({ label: label, size: size = 'medium', color: color })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.31055 2.75H12C13.1046 2.75 14 3.64543 14 4.75V6H14.6599C15.5809 6 16.2416 6.88783 15.9771 7.77002L15.3081 10H13.7419L14.4919 7.5H4.55811L2.75806 13.5H10V15H1.75C0.783502 15 0 14.2165 0 13.25V3C0 1.89543 0.895431 1 2 1H5.56055L7.31055 2.75ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V12.4731L3.14795 6.97998C3.32243 6.39838 3.85788 6 4.46509 6H12.5V4.75C12.5 4.47386 12.2761 4.25 12 4.25H6.68945L4.93945 2.5H2Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderOpenIcon"] = $6b5b62a1c1d5201a$export$d5c72b0cf938803f;

});

parcelRegister("8hkPB", function(module, exports) {
/* SmartFolderSyncIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $jY68A = parcelRequire("jY68A");

const $ae9f424642e328f9$var$i18n = (0, $aXWIB.defineMessages)({
    syncingFolder: {
        id: "smart-folder.sync-icon.syncing",
        defaultMessage: "Syncing folder"
    }
});
const $ae9f424642e328f9$var$spinAnimation = null;
const $ae9f424642e328f9$var$styles = {
    root: "_1e0c116y _4cvr1h6o _1bah1h6o _j7hqtakz _5sag7r0q _tip812c5 _1pglp3kn"
}; /**
    * A small animated sync icon shown while a smart folder is being synchronised.
    *
    * Renders a rotating `SyncIcon` wrapped in an `inline-flex` container.
    * The animation is applied to the wrapper (not the SVG itself) so that React
    * re-renders of the SVG do not reset the spin timeline.
    */ 
const $ae9f424642e328f9$export$ff90b815577daa98 = ({ testId: testId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const label = intl.formatMessage($ae9f424642e328f9$var$i18n.syncingFolder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $ae9f424642e328f9$var$styles.root,
        testId: testId,
        role: "status",
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jY68A))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};
module.exports["SmartFolderSyncIcon"] = $ae9f424642e328f9$export$ff90b815577daa98;

});

parcelRegister("jAOzg", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $9612d889a12dc002$var$createSyncStore() {
    let syncingFolderIds = new Set();
    const listeners = new Set();
    const notify = ()=>{
        listeners.forEach((listener)=>listener());
    };
    return {
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        getSnapshot: ()=>syncingFolderIds,
        addSyncingFolder: (folderId)=>{
            if (syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.add(folderId);
            syncingFolderIds = next;
            notify();
        },
        removeSyncingFolder: (folderId)=>{
            if (!syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.delete(folderId);
            syncingFolderIds = next;
            notify();
        }
    };
}
/**
 * A store-based context for tracking which folders are syncing.
 *
 * Uses `useSyncExternalStore` so that each `useIsFolderSyncing(folderId)`
 * subscriber only re-renders when their specific folder's sync boolean
 * changes — not when any arbitrary folder starts/stops syncing.
 *
 * - `SmartFolderSyncStoreContext` holds the store instance.
 * - `SmartFolderSyncActionsContext` holds stable `add`/`remove` callbacks
 *   for writers (e.g. `useSmartFolderSync`) that never re-render on state change.
 */ const $9612d889a12dc002$var$SmartFolderSyncStoreContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9612d889a12dc002$var$SmartFolderSyncActionsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    addSyncingFolder: ()=>{},
    removeSyncingFolder: ()=>{}
});
const $9612d889a12dc002$export$a225af674c9c7799 = ({ children: children })=>{
    const storeRef = (0, $42omo.useRef)(null);
    if (storeRef.current === null) storeRef.current = $9612d889a12dc002$var$createSyncStore();
    const store = storeRef.current;
    const actions = (0, $42omo.useMemo)(()=>({
            addSyncingFolder: store.addSyncingFolder,
            removeSyncingFolder: store.removeSyncingFolder
        }), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9612d889a12dc002$var$SmartFolderSyncStoreContext.Provider, {
        value: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9612d889a12dc002$var$SmartFolderSyncActionsContext.Provider, {
        value: actions
    }, children));
};
const $9612d889a12dc002$var$EMPTY_SET = new Set();
const $9612d889a12dc002$var$EMPTY_SUBSCRIBE = (_cb)=>()=>{};
const $9612d889a12dc002$var$EMPTY_SNAPSHOT = ()=>$9612d889a12dc002$var$EMPTY_SET;
const $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL = ()=>false;
const $9612d889a12dc002$export$35a8d8248145227a = ()=>{
    const store = (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    return (0, $42omo.useSyncExternalStore)(store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE, store?.getSnapshot ?? $9612d889a12dc002$var$EMPTY_SNAPSHOT, $9612d889a12dc002$var$EMPTY_SNAPSHOT);
};
const $9612d889a12dc002$export$4cd077b71db9ec99 = (folderId)=>{
    const store = (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    const subscribe = store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE;
    const getSnapshot = (0, $42omo.useCallback)(()=>store ? store.getSnapshot().has(folderId) : false, [
        store,
        folderId
    ]);
    return (0, $42omo.useSyncExternalStore)(subscribe, getSnapshot, $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL);
};
const $9612d889a12dc002$export$8a3c75bc060e9cf8 = ()=>{
    return (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncActionsContext);
};
module.exports["SmartFolderSyncProvider"] = $9612d889a12dc002$export$a225af674c9c7799;
module.exports["useIsFolderSyncing"] = $9612d889a12dc002$export$4cd077b71db9ec99;
module.exports["useFolderSyncActions"] = $9612d889a12dc002$export$8a3c75bc060e9cf8;

});

parcelRegister("8Hyz1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $2f7c8c88765be2b1$export$730cc5718beea0d0 = ()=>{
    return (0, $42omo.useContext)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext);
};
const $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $42omo.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $42omo.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["usePostOfficeSideNavMessages"] = $2f7c8c88765be2b1$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("ficwO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("ayS0g", function(module, exports) {
$parcel$export(module.exports, "PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY);
$parcel$export(module.exports, "IS_NEW_EMBED_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).IS_NEW_EMBED_QUERY_PARAM_KEY);
$parcel$export(module.exports, "DotGridBackground", () => (parcelRequire("fnyki")).DotGridBackground);
$parcel$export(module.exports, "normalizeAndValidateUrl", () => (parcelRequire("aVk5V")).normalizeAndValidateUrl);
$parcel$export(module.exports, "fetchDataFromORS", () => (parcelRequire("laZ2J")).fetchDataFromORS);
$parcel$export(module.exports, "useFetchDataFromORS", () => (parcelRequire("laZ2J")).useFetchDataFromORS);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5y1g5 = parcelRequire("5y1g5");


var $fnyki = parcelRequire("fnyki");


var $l01bG = parcelRequire("l01bG");


var $9QoCS = parcelRequire("9QoCS");


var $aVk5V = parcelRequire("aVk5V");


var $laZ2J = parcelRequire("laZ2J");


var $eaBPu = parcelRequire("eaBPu");


});

parcelRegister("5y1g5", function(module, exports) {
const $a7a321c00b90eef4$export$387a295dc04f5f90 = 'showPermissionsBanner';
const $a7a321c00b90eef4$export$3738b9a85a6948a6 = 'isNewBlankEmbed';
module.exports["PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$387a295dc04f5f90;
module.exports["IS_NEW_EMBED_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$3738b9a85a6948a6;

});

parcelRegister("fnyki", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $f37f7bd9b125a5e3$var$fullHeightContainer = (0, $ecnYn.xcss)({
    height: 'calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))'
});
const $f37f7bd9b125a5e3$var$dotGridBackground = (0, $ecnYn.xcss)({
    backgroundImage: `radial-gradient(circle at 2px 2px, ${"var(--ds-surface-overlay-hovered, #F0F1F2)"} 2px, transparent 0)`,
    backgroundSize: '20px 20px'
});
const $f37f7bd9b125a5e3$export$b520b551d14c6a6e = ({ showDottedBackground: showDottedBackground, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $f37f7bd9b125a5e3$var$fullHeightContainer,
            showDottedBackground && $f37f7bd9b125a5e3$var$dotGridBackground
        ]
    }, children);
};
module.exports["DotGridBackground"] = $f37f7bd9b125a5e3$export$b520b551d14c6a6e;

});

parcelRegister("l01bG", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");

const $f493076f7b61f977$export$b8af48de83cf2008 = (url)=>{
    const httpPattern = /^https?:\/\/[^\s]*$/im;
    return httpPattern.test(url);
};
const $f493076f7b61f977$export$285f8e8582d94002 = (data)=>{
    /*
	 * data.generator.icon.url is where provider icon is and
	 * data.icon.url is where the link icon usually is. In most cases,
	 * they are the same thing but some providers have specific icons
	 * for specific links. For example, a Google Sheet link from
	 * google-object-provider would return Google Drive icon as a provider
	 * icon (data.generator.icon.url) but would return Google Sheets icon
	 * as link icon (data.icon.url).
	 */ const generatorIconObj = data.generator?.icon;
    const iconObj = data.icon;
    const generatorIcon = generatorIconObj && (0, $a1WXB.extractUrlFromIconJsonLd)(generatorIconObj) || '';
    const icon = iconObj && (0, $a1WXB.extractUrlFromIconJsonLd)(iconObj) || '';
    // TEMP: calling isValidScheme here is a workaround to
    // ensure data URIs for favicons don't make it through
    // (BE fails as it expects a http(s) scheme). Long term,
    // we should support inlined data URI favicons.
    // https://hello.jira.atlassian.cloud/browse/CTIA-1918
    return $f493076f7b61f977$export$b8af48de83cf2008(icon) && icon || $f493076f7b61f977$export$b8af48de83cf2008(generatorIcon) && generatorIcon || '';
};
module.exports["extractIconUrl"] = $f493076f7b61f977$export$285f8e8582d94002;

});

parcelRegister("9QoCS", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");

// Gets a more specific product for the URL if we know that a provider can cover
// multiple products
const $9b10c9a9aeeff07b$var$getSpecificProduct = (hostname, providerName)=>{
    if (providerName === 'OneDrive' && hostname.includes('sharepoint')) return 'SharePoint';
    else return providerName;
};
const $9b10c9a9aeeff07b$export$a6859be1cfc01481 = (embedUrl, data)=>{
    const url = new URL(embedUrl);
    const urlHostname = url.hostname;
    // we want to remove the "www." at the beginning of the URL if it exists
    // so that the analytics are receiving domains in a consistent format
    const parsedHostname = urlHostname.replace(/^www\./, '');
    if (!data) return parsedHostname;
    const provider = (0, $a1WXB.extractProvider)(data);
    const providerName = provider?.text;
    const embedProduct = $9b10c9a9aeeff07b$var$getSpecificProduct(urlHostname, providerName);
    const providerIsHostname = embedProduct !== undefined && embedProduct.includes(parsedHostname);
    // ORS will sometimes return the urlHostname as the provider so use
    // the parsedHostname is there is no providerName or if the provider
    // contains the hostname
    if (!embedProduct || providerIsHostname) return parsedHostname;
    return embedProduct;
};
module.exports["extractProduct"] = $9b10c9a9aeeff07b$export$a6859be1cfc01481;

});

parcelRegister("aVk5V", function(module, exports) {

var $l3dur = parcelRequire("l3dur");

// regex to check that the url entered is at least of this format "://example.com"
const $9509ca2c76fbd4db$var$REGEX = /:\/\/(.*\.)?.+\..+/;
const $9509ca2c76fbd4db$export$53289a1e3dd02563 = (url)=>{
    const normalizedUrl = (0, $l3dur.normalizeUrl)(url.trim());
    // `isSafeUrl()` treats a string with just the protocol (e.g. "http://") as a valid url so we need additional check
    const isValid = !!normalizedUrl && (0, $l3dur.isSafeUrl)(normalizedUrl) && $9509ca2c76fbd4db$var$REGEX.test(normalizedUrl);
    return isValid ? normalizedUrl : null;
};
module.exports["normalizeAndValidateUrl"] = $9509ca2c76fbd4db$export$53289a1e3dd02563;

});

parcelRegister("laZ2J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $a1WXB = parcelRequire("a1WXB");


var $inPa6 = parcelRequire("inPa6");


var $l01bG = parcelRequire("l01bG");


var $aUoHg = parcelRequire("aUoHg");


var $eaBPu = parcelRequire("eaBPu");

const $07e4518f8509fec5$var$extractEmbedData = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    return {
        iconURL: data ? (0, $l01bG.extractIconUrl)(data) : undefined,
        product: (0, $eaBPu.extractEmbedProduct)({
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            data: data
        }),
        title: data ? (0, $a1WXB.extractTitle)(data) : undefined,
        url: data ? (0, $a1WXB.extractLink)(data) : undefined
    };
};
const $07e4518f8509fec5$export$7053598ec03d6366 = async ({ cardClient: cardClient, createAnalyticsEvent: createAnalyticsEvent, embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
    try {
        const details = await cardClient.fetchData(embedUrl);
        let data = details && details.data;
        let meta = details && details.meta;
        if (includeAuthHandling) {
            const authURL = meta.auth?.[0]?.url;
            if (meta.access === 'unauthorized' && authURL) {
                try {
                    await (0, $aUoHg.handleEmbedAuthentication)({
                        authURL: authURL
                    });
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'outboundAuthFlow',
                            source: 'smartLinkEmbedAuthentication',
                            attributes: {
                                error: error.type || 'unknown',
                                extensionKey: meta?.key ?? null,
                                destinationObjectType: meta?.resourceType ?? null,
                                contentType: 'embed'
                            },
                            nonPrivacySafeAttributes: {
                                linkDomain: (0, $eaBPu.extractEmbedProduct)({
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    data: data,
                                    embedUrl: embedUrl
                                })
                            }
                        }
                    }).fire();
                    return {
                        data: data,
                        meta: meta,
                        parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                            createAnalyticsEvent: createAnalyticsEvent,
                            data: data,
                            embedUrl: embedUrl
                        }),
                        error: null
                    };
                }
                // We have successfully authenticated with the URL, so lets refetch to get all the
                // proper data.
                const refetchedDetails = await cardClient.fetchData(embedUrl);
                meta = refetchedDetails && refetchedDetails.meta;
                if (refetchedDetails && refetchedDetails.data) data = refetchedDetails.data;
            }
        }
        return {
            data: data,
            meta: meta,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: data,
                embedUrl: embedUrl
            }),
            error: null
        };
    } catch (error) {
        return {
            data: undefined,
            meta: undefined,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: undefined,
                embedUrl: embedUrl
            }),
            error: error
        };
    }
};
const $07e4518f8509fec5$export$22fdc6a4626c032 = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fetchEmbedData = (0, $42omo.useCallback)(async ({ embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
        return $07e4518f8509fec5$export$7053598ec03d6366({
            cardClient: connections.client,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            includeAuthHandling: includeAuthHandling
        });
    }, [
        connections.client,
        createAnalyticsEvent
    ]);
    return {
        fetchEmbedData: fetchEmbedData
    };
};
module.exports["fetchDataFromORS"] = $07e4518f8509fec5$export$7053598ec03d6366;
module.exports["useFetchDataFromORS"] = $07e4518f8509fec5$export$22fdc6a4626c032;

});

parcelRegister("aUoHg", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");

const $1d0cc37ef4affcea$export$2b381fecab5b3691 = async ({ authURL: authURL })=>{
    const POPUP_HEIGHT = 600;
    const POPUP_WIDTH = 720;
    const BROWSER_SIZE_THRESHOLD = 48;
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Center the popup window
    const left = (vw - POPUP_WIDTH) / 2;
    const top = (vh - POPUP_HEIGHT) / 2;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > POPUP_WIDTH + BROWSER_SIZE_THRESHOLD && vh > POPUP_HEIGHT + BROWSER_SIZE_THRESHOLD ? `width=${POPUP_WIDTH},height=${POPUP_HEIGHT}},left=${left},top=${top}` : undefined;
    await (0, $3uVVG.auth)(authURL, windowFeatures);
};
module.exports["handleEmbedAuthentication"] = $1d0cc37ef4affcea$export$2b381fecab5b3691;

});

parcelRegister("eaBPu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9QoCS = parcelRequire("9QoCS");

const $86c9e03e9bf37880$export$c6a11f4b62c81749 = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    try {
        return (0, $9QoCS.extractProduct)(embedUrl, data || undefined);
    } catch (error) {
        createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'embedProductExtraction',
                source: 'smartLinkEmbedProductExtraction',
                attributes: {
                    contentType: 'embed'
                }
            }
        }).fire();
        return null;
    }
};
const $86c9e03e9bf37880$export$fe632efa34893174 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const _extractEmbedProduct = (0, $42omo.useCallback)(({ data: data, embedUrl: embedUrl })=>{
        return $86c9e03e9bf37880$export$c6a11f4b62c81749({
            createAnalyticsEvent: createAnalyticsEvent,
            data: data,
            embedUrl: embedUrl
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        extractEmbedProduct: _extractEmbedProduct
    };
};
module.exports["extractEmbedProduct"] = $86c9e03e9bf37880$export$c6a11f4b62c81749;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("gMtye", function(module, exports) {
const $1fd4d6f991517194$export$28213145aa06a6b9 = 'is-smart-link-dragging';
const $1fd4d6f991517194$export$a20e94b83f364b00 = 'smart-link-drop-over';
const $1fd4d6f991517194$export$9cd8e72bb371a8c0 = 'smartLinkDnD';
module.exports["smartLinkDropOverClass"] = $1fd4d6f991517194$export$a20e94b83f364b00;
module.exports["SMART_LINK_DND_ANALYTICS_SOURCE"] = $1fd4d6f991517194$export$9cd8e72bb371a8c0;

});

parcelRegister("gAsUX", function(module, exports) {
/* SmartLinkDropTarget.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $f9yl5 = parcelRequire("f9yl5");


var $4T4vf = parcelRequire("4T4vf");


var $9wGTI = parcelRequire("9wGTI");


var $gMtye = parcelRequire("gMtye");

const $da2fe9c7e62c2676$var$EDGE_BORDER_HIDE_THRESHOLD_PX = 8;
const $da2fe9c7e62c2676$var$topBorderColorVar = '--smart-link-drop-target-border-top-color';
const $da2fe9c7e62c2676$var$bottomBorderColorVar = '--smart-link-drop-target-border-bottom-color';
const $da2fe9c7e62c2676$var$smartLinkDropTargetStyles = null;
function $da2fe9c7e62c2676$export$427c9f1706ef8816({ onDropped: onDropped, children: children, className: className, hideHoveredEdgeBorder: hideHoveredEdgeBorder = false }) {
    const ref = (0, $42omo.useRef)(null);
    const clearHoveredEdgeBorder = (0, $42omo.useCallback)((element)=>{
        element.style.removeProperty($da2fe9c7e62c2676$var$topBorderColorVar);
        element.style.removeProperty($da2fe9c7e62c2676$var$bottomBorderColorVar);
    }, []);
    const updateHoveredEdgeBorder = (0, $42omo.useCallback)((element, clientY)=>{
        if (!hideHoveredEdgeBorder) {
            clearHoveredEdgeBorder(element);
            return;
        }
        const rect = element.getBoundingClientRect();
        const threshold = Math.min($da2fe9c7e62c2676$var$EDGE_BORDER_HIDE_THRESHOLD_PX, rect.height / 2);
        const distanceFromTop = clientY - rect.top;
        const distanceFromBottom = rect.bottom - clientY;
        const isNearTop = distanceFromTop >= 0 && distanceFromTop <= threshold && distanceFromTop <= distanceFromBottom;
        const isNearBottom = distanceFromBottom >= 0 && distanceFromBottom <= threshold && distanceFromBottom < distanceFromTop;
        if (isNearTop) {
            element.style.setProperty($da2fe9c7e62c2676$var$topBorderColorVar, 'transparent');
            element.style.removeProperty($da2fe9c7e62c2676$var$bottomBorderColorVar);
            return;
        }
        if (isNearBottom) {
            element.style.setProperty($da2fe9c7e62c2676$var$bottomBorderColorVar, 'transparent');
            element.style.removeProperty($da2fe9c7e62c2676$var$topBorderColorVar);
            return;
        }
        clearHoveredEdgeBorder(element);
    }, [
        clearHoveredEdgeBorder,
        hideHoveredEdgeBorder
    ]);
    const updateHoveredEdgeBorderFromLocation = (0, $42omo.useCallback)((element, location)=>{
        const clientY = location?.current?.input?.clientY;
        if (typeof clientY !== 'number') {
            clearHoveredEdgeBorder(element);
            return;
        }
        updateHoveredEdgeBorder(element, clientY);
    }, [
        clearHoveredEdgeBorder,
        updateHoveredEdgeBorder
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return;
        const el = ref.current;
        if (!el) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>(0, $f9yl5.isSmartLinkDrag)(source.data.type),
            onDragEnter: (args)=>{
                el.classList.add((0, $gMtye.smartLinkDropOverClass));
                updateHoveredEdgeBorderFromLocation(el, args?.location);
            },
            onDrag: (args)=>{
                updateHoveredEdgeBorderFromLocation(el, args?.location);
            },
            onDragLeave: ()=>{
                el.classList.remove((0, $gMtye.smartLinkDropOverClass));
                clearHoveredEdgeBorder(el);
            },
            onDrop: ({ source: source })=>{
                el.classList.remove((0, $gMtye.smartLinkDropOverClass));
                clearHoveredEdgeBorder(el);
                onDropped?.(source.data);
            }
        });
    }, [
        clearHoveredEdgeBorder,
        onDropped,
        updateHoveredEdgeBorderFromLocation
    ]);
    if (!(0, $9wGTI.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1bsb1osq _kqswh2mm _12ri1j28 _2ou61xzb _jk5h1xzb _1tesidpf _14h8nj19 _rfx31kw7 _1kt9b3bt _1cs8stnw _xhvgdmyn _1evj3iac _dsq4glyw _15clq98m _2qe3ufnl _yt11q98m",
            className
        ])
    }, children);
}
module.exports["SmartLinkDropTarget"] = $da2fe9c7e62c2676$export$427c9f1706ef8816;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<4f1511016f30960d1bbc443c21231347>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("dd6Gw", function(module, exports) {
// This type matches the GraphQL result from fetching something with `properties`.
const $411dffa4c6a383d3$export$9f5d37e817ec8d6 = (page)=>{
    const editorProperty = page?.properties?.nodes?.find((prop)=>prop?.key === 'editor');
    const editorVersion = (editorProperty?.value || '').replace(/['"]+/g, '');
    if (editorVersion !== 'v1' && editorVersion !== 'v2') return '';
    else return editorVersion;
};
module.exports["getEditorVersionFromPageProperties"] = $411dffa4c6a383d3$export$9f5d37e817ec8d6;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("jwg5H", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ed61048aa16089ca$export$a423abb15d3d6d30 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOnQb",
    name: "BulkDeletePagesActionLoader",
    loader: async ()=>(await (parcelRequire("cyNQs"))).BulkDeletePagesAction
});
module.exports["BulkDeletePagesActionLoader"] = $ed61048aa16089ca$export$a423abb15d3d6d30;

});

parcelRegister("cyNQs", function(module, exports) {

let $924f5335b4c5d9b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $924f5335b4c5d9b3$var$load("6wr18"),
    $924f5335b4c5d9b3$var$load("33ouG"),
    $924f5335b4c5d9b3$var$load("73HOd"),
    $924f5335b4c5d9b3$var$load("ffEVr"),
    $924f5335b4c5d9b3$var$load("Wowvf"),
    $924f5335b4c5d9b3$var$load("8W6BK"),
    $924f5335b4c5d9b3$var$load("hhss7"),
    $924f5335b4c5d9b3$var$load("4JUnA")
]).then(()=>parcelRequire('11cB0'));

});

parcelRegister("eQjI7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xv9Y3",
    name: "BulkArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("3YGSd"))).BulkArchivePagesLoader
});
module.exports["BulkArchivePagesLoader"] = $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb;

});

parcelRegister("3YGSd", function(module, exports) {

let $2e583b762cd80d85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e583b762cd80d85$var$load("5HAR6"),
    $2e583b762cd80d85$var$load("arLFU"),
    $2e583b762cd80d85$var$load("hCiBy"),
    $2e583b762cd80d85$var$load("9qfB8"),
    $2e583b762cd80d85$var$load("6wr18"),
    $2e583b762cd80d85$var$load("jyWy1"),
    $2e583b762cd80d85$var$load("kHOMt"),
    $2e583b762cd80d85$var$load("ffEVr"),
    $2e583b762cd80d85$var$load("Wowvf"),
    $2e583b762cd80d85$var$load("8W6BK"),
    $2e583b762cd80d85$var$load("hhss7"),
    $2e583b762cd80d85$var$load("anGwD")
]).then(()=>parcelRequire('1nPts'));

});

parcelRegister("abCbd", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $49f30f782ee3886b$export$dde867dc2e19cdfb = /*#__PURE__*/ function(ActionStatus) {
    ActionStatus["LOADING"] = "loading";
    ActionStatus["ERROR"] = "error";
    ActionStatus["SUCCESS"] = "success";
    return ActionStatus;
}({});
const $49f30f782ee3886b$export$a047e1504a58a095 = 'https://support.atlassian.com/contact/#/';
const $49f30f782ee3886b$export$992f6917cca3802d = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/';
const $49f30f782ee3886b$export$f077813e47f96ab7 = 'https://support.atlassian.com/confluence-cloud/docs/delete-restore-or-purge-a-page/';
const $49f30f782ee3886b$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
var $49f30f782ee3886b$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["ARCHIVED"] = "archived";
    ContentStatus["RESTORED"] = "restored";
    // Trashed pages can be restored.
    ContentStatus["TRASHED"] = "trashed";
    return ContentStatus;
}({});
const $49f30f782ee3886b$export$c047260051351df3 = 100;
module.exports["ActionStatus"] = $49f30f782ee3886b$export$dde867dc2e19cdfb;
module.exports["LINK_TO_SUPPORT_CONTACT"] = $49f30f782ee3886b$export$a047e1504a58a095;
module.exports["ARCHIVE_SUPPORT_LINK"] = $49f30f782ee3886b$export$992f6917cca3802d;
module.exports["DELETE_SUPPORT_LINK"] = $49f30f782ee3886b$export$f077813e47f96ab7;
module.exports["PAGE_RESTRICTIONS_SUPPORT_LINK"] = $49f30f782ee3886b$export$90622b83e51be397;
module.exports["ContentStatus"] = $49f30f782ee3886b$export$b2be22e9d5dd3927;
module.exports["BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT"] = $49f30f782ee3886b$export$c047260051351df3;

});

parcelRegister("g0MxG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ab7921964510845f$export$e3668039106e3bc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CQdGh",
    name: "PageTreeAfterIconLoader",
    loader: async ()=>(await (parcelRequire("21ycD"))).PageTreeAfterIcon
});
module.exports["PageTreeAfterIconLoader"] = $ab7921964510845f$export$e3668039106e3bc;

});

parcelRegister("21ycD", function(module, exports) {

let $179634b83e77220d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $179634b83e77220d$var$load("6wr18"),
    $179634b83e77220d$var$load("jJSpQ"),
    $179634b83e77220d$var$load("ffEVr"),
    $179634b83e77220d$var$load("kFiBp"),
    $179634b83e77220d$var$load("dkv9z")
]).then(()=>parcelRequire('4Nj9v'));

});


//# sourceMappingURL=PageTree.f12ffd03.js.map
